import { FC } from 'react';
import { IconButtonProps } from './types';
import Button from '../Button';

const IconButton: FC<React.PropsWithChildren<IconButtonProps>> = ({
  children,
  disabled = false,
  variant = 'main',
  size = 'medium',
  isLoading = false,
  ...rest
}) => {
  return (
    <Button
      {...rest}
      size={size}
      variant={variant}
      isLoading={isLoading}
      disabled={disabled}
      startIcon={children}
    ></Button>
  );
};

export default IconButton;
